import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

import { getViewPermission } from "../getViewPermission";

const FeatureFlagsForNro = lazy(() =>
  import("@scenes/FeatureFlags/FeatureFlagsForNro").then((module) => ({
    default: module.FeatureFlagsForNro,
  }))
);

export const featureFlagsNRO: NavigationRoutingObject = {
  Component: FeatureFlagsForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("feature-flags-sidebar-pill-menu-option", "Feature Flags"),
  pageNameForTracking: () => "Feature Flags",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "feature-flags-sidebar-pill-menu-option-description",
      "Remotely turn native functionality on or off in your app for a selection of users"
    ),
  icon: "new-nav-system-feature-flags",
  featureLimitationKeys: ["can_only_view_landing_page_feature_flags"],
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return getViewPermission(featureOn, hasPermission);
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    feature_flags: makeAdditionalSearchableFeature({
      heading: t("feature-flags-sidebar-pill-menu-option", "Feature Flags"),
      pathname: "/engagement/feature_flags/:featureFlagId/:appGroupId",
      query: { featureFlagId: "feature_flags" },
      description: t(
        "feature-flags-sidebar-pill-menu-option-description",
        "Remotely turn native functionality on or off in your app for a selection of users"
      ),
      additionalSearchTerms: [
        {
          keywords: [t("feature-flags-alt-keyword-1", "feature flippers")],
        },
      ],
    }),
  }),
  defaultRoute: "/engagement/feature_flags/:appGroupId",
};
